<template>
  <div id="app">
    <div id="home">
      <div class="homeContent" :style="{'width':(clinetType == 'A'?'120rem':'85.375rem')}">
        <div class="nav">
          <div class="company">
            <img class="companyLogo" src="@/assets/companyLogo.png" alt="">
            <p class="companyName">中创创富(福州)投资有限公司</p>
          </div>
          <div class="btnGroup">
            <a href="#home" :class="['btn',{'selectBtn':current==0}]" @click="jump(0)">
              <span>首页</span>
            </a>
            <a href="#product" :class="['btn',{'selectBtn':current==1}]" @click="jump(1)">
              <span>产品介绍</span>
            </a>
            <a href="#about" :class="['btn',{'selectBtn':current==2}]" @click="jump(2)">
              <span>关于我们</span>
            </a>
            <a href="#contact" :class="['btn',{'selectBtn':current==3}]" @click="jump(3)">
              <span>联系方式</span>
            </a>
          </div>
        </div>
        <div class="homeTitleBox">
          <img class="homeTitle" :style="{'width':(clinetType == 'A'?'47.5rem':'31.25rem'),'height':(clinetType == 'A'?'14.375rem':'9.5rem')}" src="@/assets/homeTitle.png" alt="">
        </div>
        <div class="batteryBox">
          <img class="battery" :style="{'width':(clinetType == 'A'?'31.375rem':'25.125rem'),'height':(clinetType == 'A'?'37.375rem':'29.9rem')}" src="@/assets/battery.png" alt="">
        </div>
      </div>
    </div>
    <div id="product">
      <div class="productContent product1" :style="{'width':(clinetType == 'A'?'120rem':'85.375rem')}">
        <p class="p1Title">产品介绍</p>
        <div class="titleLine"></div>
        <p class="p1TitleE">Product introduction</p>
        <div class="p1Text">
          <p>设备桌下安装，桌面使用，节约空间，且视觉感官比桌面底座更好；桌贴防水、可更换，不怕油污，清洁方便，不担心卫生问题；对比传统有线充电宝充电更稳定，</p>
          <p>不需要插入手机电源口，不需要归还，不需要押金，不需要信用，随充随走指示说明清晰，使用方式简单，方便各种年龄段的顾客。</p>
        </div>
        <div class="PC1Icon">
          <img class="PC1IconItem" style="height:12.6875rem" src="@/assets/p1_img1.png" alt="">
          <img class="PC1IconItem" src="@/assets/p1_img2.png" alt="">
          <img class="PC1IconItem" src="@/assets/p1_img3.png" alt="">
          <img class="PC1IconItem" src="@/assets/p1_img4.png" alt="">
        </div>
      </div>
    </div>
    <div id="product">
      <div class="productContent" :style="{'width':(clinetType == 'A'?'120rem':'85.375rem')}">
        <img class="p2Img" src="@/assets/p2_img.png" alt="">
      </div>
    </div>
    <div id="product">
      <div class="productContent product3">
        <div class="PC3Icon">
          <img class="PC3IconItem" src="@/assets/p3_img1.png" alt="">
          <img class="PC3IconItem" src="@/assets/p3_img2.png" alt="">
          <img class="PC3IconItem" src="@/assets/p3_img3.png" alt="">
          <img class="PC3IconItem" src="@/assets/p3_img4.png" alt="">
        </div>
        <div class="p3Text">
          <p>符合创新创造绿色环保、智能节约、安全便捷的新型理念，易于推广。</p>
          <p>JM共享无限充电宝，有自主智能生产制造工厂，</p>
          <p>各个元器件均使用环保材料，强大的研发实力铸就知识产权壁垒。</p>
        </div>
        <div class="p3ImgBox">
          <img class="p3Img" src="@/assets/p3_img5.png" alt="">
        </div>
      </div>
    </div>
    <div id="about">
      <div class="aboutContent" :style="{'width':(clinetType == 'A'?'120rem':'85.375rem')}">
        <p class="aboutTitle">关于我们</p>
        <div class="titleLine"></div>
        <p class="aboutTitleE">About us</p>
        <div class="aboutText">
          <p>中创创富致力于无线充电技术的研发，公司产品符合Qi或Airfuel标准，并在标准的基础上，对充电距离、</p>
          <p>充电面积等关键参数做了大幅优化，竞争优势明显。目前，公司旗下品牌JM共享无线充电已正式投放市</p>
          <p>场，市场反馈强烈，中创创富亦可提供专业的定制方案。产品可广泛运用于电子穿戴设备、手机及配件、</p>
          <p>笔记本电脑及配件、电动汽车、医疗设备等领域，与传统电子产品的结合，带来的不仅是充电方式的改变，</p>
          <p>更是让产品的使用体验产生巨大的变革。</p>
        </div>
        <div class="aboutIcon">
          <img class="aboutImg" src="@/assets/about_img1.png" alt="">
        </div>
      </div>
    </div>
    <div id="contact">
      <div class="contactContent" :style="{'width':(clinetType == 'A'?'120rem':'85.375rem')}">
        <p class="contactTitle">联系我们</p>
        <div class="titleLine" style="background-color:#ffffff"></div>
        <p class="contactTitleE">Contact us</p>
        <div class="contactInfo">
          <div class="contactInfoL">
            <div class="contactInfoLItem">
              <img class="infoLItemIcon" src="@/assets/icon_qq.png" alt="">
              <p>QQ：648030466</p>
            </div>
            <div class="contactInfoLItem">
              <img class="infoLItemIcon" src="@/assets/icon_wx.png" alt="">
              <p>微信：648030466</p>
            </div>
            <div class="contactInfoLItem">
              <img class="infoLItemIcon" src="@/assets/icon_tel.png" alt="">
              <p>联系电话：648030466</p>
            </div>
            <div class="contactInfoLItem">
              <img class="infoLItemIcon" src="@/assets/icon_emil.png" alt="">
              <p>邮箱：13905912440@163.com</p>
            </div>
            <div class="contactInfoLItem">
              <img class="infoLItemIcon" src="@/assets/icon_addr.png" alt="">
              <p>联系地址：福建省福州市台江区金融街万达中心607</p>
            </div>
          </div>
          <div class="contactInfoR">
            <div class="InfoRCode">
              <img class="infoRItemIcon" src="@/assets/gzhQRCode.png" alt="">
              <p>公众号</p>
            </div>
            <div class="InfoRCode">
              <img class="infoRItemIcon" src="@/assets/kfQRCode.png" alt="">
              <p>在线客服</p>
            </div>
          </div>
        </div>
        <div class="contactLine"></div>
        <div class="copyright">
          <p>中创创富(福州)投资有限公司©2022 JM隔空无线充电 共享充电宝加盟-共享充电宝代理 共享充电宝合作 版权所有</p>
          <a style="margin-top: 10px;" href="https://beian.miit.gov.cn">闽ICP备2024050692号</a>
        </div>
      </div>
    </div>
    <a class="toTop" v-if="showToTop" href="#home" @click="current = 0">
      <p>返回</p>
      <p>顶部</p>
    </a>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      clinetType: 'A',
      current: 0,
      showToTop: false
    }
  },
  created() {
    // const W = window.screen.width
    const W = document.body.clientWidth
    // console.log(W)
    // console.log(document.body.clientWidth)
    if(W > 1920) {
      this.clinetType = 'A'
    } else if (W > 1366 & W < 1920){
      this.clinetType = 'B'
    }
  },
  mounted() {
    window.addEventListener("scroll",this.handleScroll); 
  },
  destroyed() {
    documentNaNpxoveEventListener('scroll', this.handleScroll)
  },
  methods: {
    jump(i) {
      this.current = i
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop)
      if (scrollTop < 400) {
        //滚动小于400的时候要做的操作
        this.showToTop = false
      }
      if (scrollTop > 400) {
        //大于800的时候要做的操作
        this.showToTop = true
      }
    }
  }
}
</script>

<style>
/* 清除内外边距 */
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
fieldset, lengend, button, input, textarea, /* form elements 表单元素 */
th, td { /* table elements 表格元素 */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a{ text-decoration:none; outline: none; color: #000;}
a:hover img{ border:none;}
html{ scroll-behavior: smooth; }

#app{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#home{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F6D743;
}
.homeContent{
  /* width: 120rem; */
  height: 60rem;
  position: relative;
}
.nav{
  width: 100%;
  height: 6.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5rem;
}
.company{
  display: flex;
  align-items: center;
}
.companyLogo{
  width: 4.25rem;
  height: 3.375rem;
  margin-right: .75rem;
}
.companyName{
  font-size: 1.875rem;
}
.btnGroup{
  display: flex;
}
.btn{
  height: 3.125rem;
  padding: 0 2.5rem;
  border-radius: 1.5625rem;
  margin-left: 1.25rem;
  color: #222222;
  line-height: 3.125rem;
  font-size: 1.125rem;
}
.selectBtn{
  color: #FFFFFF;
  background-color: #222222;
}
.selectBtn a{
  color: #FFFFFF;
}
.homeTitleBox{
  margin-top: 15.75rem;
  margin-left: 11.125rem;
}
.homeTitle{
  width: 47.5rem;
  height: 14.375rem;
}
.batteryBox{
  position: absolute;
  bottom: 0;
  right: 11.625rem;
}
#product{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;
  box-shadow: 0 -5px 30px -5px #C9C9C9C9 inset;
}
.productContent{
  /* width: 120rem; */
  height: 60rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.p1Title{
  font-size: 2.25rem;
  color: #222222;
  margin-top: 13rem;
}
.titleLine{
  width: 3.75rem;
  height: .25rem;
  background-color: #F6D743;
  border-radius: .125rem;
  margin: .625rem;
}
.p1TitleE{
  font-size: 1.25rem;
  color: #999999;
}
.p1Text{
  color: #666666;
  font-size: 1.125rem;
  margin: 4rem 0 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PC1Icon{
  width: 80%;
  display: flex;
  justify-content: space-around;
}
.PC1IconItem{
  width: 10.9375rem;
  height: 13.9375rem;
}
.p2Img{
  width: 67.5rem;
  height: 45.3125rem;
  margin-top: 7.5rem;
}
.product3{
  position: relative;
}
.PC3Icon{
  width: 60%;
  margin-top: 6rem;
  display: flex;
  justify-content: space-around;
}
.PC3IconItem{
  width: 10.4375rem;
  height: 11.0625rem;
}
.p3Text{
  color: #222222;
  font-size: 1.125rem;
  margin: 10rem 0 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.p3ImgBox{
  width: 100%;
  display: flex;
  justify-content: center;
  height: 17.8125rem;
  position: absolute;
  right: 0;
  bottom: 0;
}
.p3Img{
  width: 11.875rem;
  height: 17.8125rem;
}
#about{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;
  box-shadow: 0 -5px 30px -5px #C9C9C9C9 inset;
}
.aboutContent{
  /* width: 120rem; */
  height: 60rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.aboutTitle{
  font-size: 2.25rem;
  color: #222222;
  margin-top: 10rem;
}
.aboutTitleE{
  font-size: 1.25rem;
  color: #999999;
}
.aboutText{
  color: #222222;
  font-size: 1.125rem;
  margin: 4rem 0 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.aboutImg{
  width: 26.0625rem;
  height: 22.4375rem;
}
#contact{
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F6D743;
}
.contactContent{
  /* width: 120rem; */
  height: 60rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contactTitle{
  font-size: 2.25rem;
  color: #222222;
  margin-top: 10rem;
}
.contactTitleE{
  font-size: 1.25rem;
  color: #CEB331;
}
.contactInfo{
  width: 70%;
  height: 31.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contactInfoL{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #222222;
  font-size: 1.25rem;
}
.contactInfoLItem{
  display: flex;
  align-items: center;
  margin: .3125rem 0;
}
.infoLItemIcon{
  width: 3rem;
  height: 3rem;
  margin-right: .625rem;
}
.contactInfoR{
  display: flex;
}
.InfoRCode{
  width: 10rem;
  height: 12.5rem;
  margin-left: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 1.25rem;
}
.infoRItemIcon{
  width: 10rem;
  height: 10rem;
}
.contactLine{
  width: 100%;
  height: 1px;
  background-color: #222222;
}
.copyright{
  margin-top: 3.75rem;
  color: #222222;
  font-size: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.toTop{
  display: inline-block;
  position: fixed;
  right: 2.5rem;
  bottom: 6.25rem;
  width: 3.125rem;
  height: 3.125rem;
  background-color: darkcyan;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  border: .125rem solid #999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue